import { render } from "./Swiper.vue?vue&type=template&id=bcab241e&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=bcab241e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcab241e"]])

export default __exports__